module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerMessage",
    style: ({
      'background-color': 'none'
    })
  }, [_c('ul', {
    staticClass: "ulMessageMenu"
  }, _vm._l((_vm.getObjectMenu(_vm.message.message)), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "liMessageMenu",
      class: _vm.optionClicked ? 'changeCursor ' + (index + 1 !== _vm.optionClicked ? 'notselected' : 'selected') : 'selected',
      style: ({
        'border-color': _vm.$store.state.campaign.color,
        'color': _vm.invertColor(_vm.$store.state.campaign.color, true, true)
      }),
      on: {
        "click": function($event) {
          return _vm.sendMessage(item.option, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left",
        "position": "absolute",
        "top": "6px"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("\n          keyboard_arrow_right\n          " + _vm._s(item.option) + "\n        ")])]), _vm._v(" "), _vm._l((item.optionName), function(e) {
      return _c('p', {
        key: e.optionName,
        staticClass: "pMessageMenu",
        class: _vm.optionClicked ? 'changeCursor' : '',
        style: ({
          'color': _vm.invertColor(_vm.$store.state.campaign.color, true, true),
          'font-size': '14px',
          'font-family': 'Lato'
        })
      }, [_c('a', {
        class: _vm.optionClicked ? 'changeCursor' : '',
        style: ({
          'color': _vm.invertColor(_vm.$store.state.campaign.color, true, true),
          'font-size': '14px',
          'font-family': 'Lato'
        })
      }, [_vm._v(_vm._s(e))])])
    })], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f28b83e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messageMenu.vue
// module id = 402
// module chunks = 2